import { render } from "./SaveEmployee.vue?vue&type=template&id=22016eaa&scoped=true"
import script from "./SaveEmployee.vue?vue&type=script&lang=js"
export * from "./SaveEmployee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=22016eaa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22016eaa"]])

export default __exports__